import { AssistQueryClient } from 'services/assist-api/query-client';

/**
 * Clears the queries used to populate the Marking tables so that these will
 * contain the new allocations and status changes:
 */
export function refreshMarkingTables(): void {
  AssistQueryClient.removeQueries(['test-instance-response-markers/marking-tasks']);
  AssistQueryClient.removeQueries(['test-instance-responses/marker-allocation']);
  AssistQueryClient.removeQueries(['test-instance-response-marks']);
}
